export default __webpack_public_path__ + "maps-examples-user-tracking-mode-thumbnail-480-d09d99ce6f5185012d8cf2ab17504749.png";